import React, { useEffect } from "react";
import FarmerDetails from "../../components/admin/Farmer-Details";



const FarmerDetailsPage = () => {

    useEffect(() => {
        document.body.id = "farmer-details-002";
      }, []);

  return (
    <div>
    <FarmerDetails />
    </div>
  );
};

export default FarmerDetailsPage;
